module.exports = __webpack_public_path__ + "static/Aneta_2_min-ae1556418e8d795ce76cb72a9b3eb792.jpg";